export function createFinalizationRegistry() {
    if (typeof FinalizationRegistry === 'function') {
        return new FinalizationRegistry(cleanupCallback => {
            cleanupCallback();
        });
    }
    return undefined;
}
//# sourceMappingURL=finalizationRegistry.js.map